<template>
  <div id="about-page">
    <ParallaxHeader :headline="'About Us'" :slogan="''"/>
    <v-container fluid grid-list-xl>
      <v-layout row wrap justify-center>
        <About/>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import About from '@/components/About'
import ParallaxHeader from '@/components/ParallaxHeader'

export default {
  components: {
    About,
    ParallaxHeader
  }
}
</script>

<style scoped>
#about-page {
  font-family: 'Lato', sans-serif;
}
#page-name {
  font-size: 3.5vmax;
  font-family: 'Vollkorn', serif;
}
</style>


// WEBPACK FOOTER //
// src/pages/AboutPage.vue